import type {AppDispatch} from 'store'
import RingQueue from './ringQueue'
import {cacheService} from 'utils/cache.service'
import {describeUser} from 'api/action/describeUser'

const MAX_CONCURRENT = 15
const MAX_QUEUE_SIZE = 10000

class DescribeUser {
    private _userQueue = new RingQueue<string>(MAX_QUEUE_SIZE)

    private _dispatch: AppDispatch | null = null

    private _queued: Set<string> = new Set()

    private _inFlight: Set<string> = new Set()

    setDispatch(dispatch: AppDispatch): void {
        this._dispatch = dispatch
        this._pump()
    }

    clear(): void {
        this._userQueue.clear()
        this._queued.clear()
        this._inFlight.clear()
    }

    enqueue(userIds: string[]): void {
        for (const id of userIds) {
            if (!id) {
                // eslint-disable-next-line no-continue
                continue
            }
            if (cacheService.has(id) || this._inFlight.has(id) || this._queued.has(id)) {
                // eslint-disable-next-line no-continue
                continue
            }

            const droppedId = this._userQueue.enqueue(id)
            if (droppedId) {
                this._queued.delete(droppedId)
            }
            this._queued.add(id)
        }

        this._pump()
    }

    private _pump(): void {
        if (!this._dispatch) {
            return
        }

        const dispatch = this._dispatch
        const slots = MAX_CONCURRENT - this._inFlight.size
        const itemsToStart = Math.min(slots, this._userQueue.count)

        for (let index = 0; index < itemsToStart; index += 1) {
            const userId = this._userQueue.dequeue()
            if (!userId) {
                // eslint-disable-next-line no-continue
                continue
            }
            this._queued.delete(userId)
            this._inFlight.add(userId)
            cacheService.add(userId)

            dispatch(describeUser({user_id: userId})).finally(() => {
                this._inFlight.delete(userId)
                this._pump()
            })
        }
    }
}

export const describeUserBuffer = new DescribeUser()
